import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '../plugins/i18n'
import store from '../store'

const HomePage = () => import('../views/HomePage.vue')
const DetailPage = () => import('../views/DetailPage.vue')
const FavoritesPage = () => import('../views/FavoritesPage.vue')
const AdvicePage = () => import('../views/AdvicePage.vue')
const NotFoundPage = () => import('../views/NotFoundPage.vue')

Vue.use(VueRouter)

const currentLocale = location.pathname.split('/')[1]
let locales = store.state.locales

if (locales.includes(currentLocale)) {
  if (currentLocale) i18n.locale = currentLocale

  locales.push(currentLocale)
  locales.reverse()
  locales = [...new Set(locales)]
}

const routes = [
  {
    path: '/:locale',
    name: 'HomePage',
    component: HomePage,
    props: true,
  },
  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
  },
  ...locales.map((locale) => {
    return {
      path: `/:locale/${i18n.t('router.venue', locale)}/:slug`,
      name: 'DetailPage',
      component: DetailPage,
      props: true,
    }
  }),
  ...locales.map((locale) => {
    return   {
      path: `/:locale/${i18n.t('router.my-venues', locale)}`,
      name: 'FavoritesPage',
      component: FavoritesPage,
      props: true,
    }
  }),
  ...locales.map((locale) => {
    return     {
      path: `/:locale/${i18n.t('router.advices', locale)}`,
      name: 'AdvicePage',
      component: AdvicePage,
      props: true,
    }
  }),
  {
    path: '*',
    name: 'NotFoundPage',
    component: NotFoundPage,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes,
})

router.afterEach((to, from) => {
  if (!store.state.isOnline) return
  if (from.params.locale && (from.params.locale !== to.params.locale)) window.location.reload()
})

export default router
